import axios from "axios";
import store from "@/store";

export default {
  data(){
    return {}
  },
  methods: {

    /* Auth */

    loginEGI(){
      if (this.$route.query.redirect) sessionStorage.setItem("redirect", this.$route.query.redirect);
      else sessionStorage.removeItem("redirect")
      this.$router.push("/oidc")
    },

    logoutEGI(){
      localStorage.removeItem('session')
      store.state.isLogged = false
      this.$router.push('/')
    },

    checkAuthCall(callBackHandler){
      let session = JSON.parse(localStorage.getItem("session"));
      let token = session.access_token;
      $.ajax({
        type: 'POST',
        url: process.env.VUE_APP_AUTHORITY + '/protocol/openid-connect/userinfo',
        contentType: 'application/json',
        headers: { 'Authorization': 'Bearer ' + token },
        success: result => callBackHandler(result),
        error:   error  => callBackHandler(error)
      })
    },


    /* Common PaaS & QAA modules */

    getCriteriaCall(callBackHandler, assessment = false){
      axios.get(process.env.VUE_APP_API + (assessment? '/criteria?assessment=true' : '/criteria'))
        .then (response => callBackHandler(response))
        .catch(error    => callBackHandler(error.response))
    },

    checkStatusCall(pipeline_id, callBackHandler){
      axios.get(process.env.VUE_APP_API + '/pipeline/' + pipeline_id + '/status')
        .then(response => callBackHandler(response))
        .catch(error =>   callBackHandler(error.response))
    },


    /* Pipeline as a Service Module */

    createPipelineCall(data, callBackHandler) {
      axios.post(process.env.VUE_APP_API + '/pipeline', data)
      .then(response => callBackHandler(response))
      .catch(error =>   callBackHandler(error.response))
    },

    runPipelineCall(data, callBackHandler){
      axios.post(process.env.VUE_APP_API + '/pipeline/' + data.id + '/run?issue_badge=true&repo_url=' + data.url + '&repo_branch=' + data.branch + '&keepgoing=' + data.keepgoing)
        .then(response => callBackHandler(response))
        .catch(error =>    callBackHandler(error.response))
    },

    getConfigCall(id, callBackHandler){
      axios.get(process.env.VUE_APP_API + '/pipeline/' + id + '/config/jepl')
        .then(response => callBackHandler(response))
        .catch(error =>   callBackHandler(error.response))
    },

    getBuilderScriptCall(id, callBackHandler){
      axios.get(process.env.VUE_APP_API + '/pipeline/' + id + '/config/scripts')
        .then(response => callBackHandler(response))
        .catch(error =>   callBackHandler(error.response))
    },

    getComposerCall(id, callBackHandler){
    axios.get(process.env.VUE_APP_API + '/pipeline/' + id + '/composer/jepl')
      .then(response => callBackHandler(response))
      .catch(error   => callBackHandler(error.response))
    },

    getJenkinsCall(id, callBackHandler){
      axios.get(process.env.VUE_APP_API + '/pipeline/' + id + '/jenkinsfile/jepl')
        .then(response => callBackHandler(response))
        .catch(error   => callBackHandler(error.response))
    },

    pullRequestCall(id, data, callBackHandler){
      axios.post(process.env.VUE_APP_API + '/pipeline/' + id + '/pull_request', data)
        .then(response =>  callBackHandler(response))
        .catch(error =>    callBackHandler(error.response))
    },


    /* Quality Assessment & Awarding Module */

    createAssessmentPipelineCall(data, callBackHandler){
      axios.post(process.env.VUE_APP_API + '/pipeline/assessment', data)
        .then(response => callBackHandler(response))
        .catch(error =>  callBackHandler(error.response))
    },

    runAssessmentPipelineCall(pipeline_id, callBackHandler){
      axios.post(process.env.VUE_APP_API + '/pipeline/' + pipeline_id + '/run')
        .then(response => callBackHandler(response))
        .catch(error => callBackHandler(error.response))
    },

    deletePipelineCall(pipeline_id, callBackHandler) {
      axios.delete(process.env.VUE_APP_API + '/pipeline/' + pipeline_id)
        .then(response => callBackHandler(response))
        .catch(error =>   callBackHandler(error.response))
    },

    getOutputCall(pipeline_id, callBackHandler){
      axios.get(process.env.VUE_APP_API + '/pipeline/assessment/' + pipeline_id + '/output')
        .then(response => callBackHandler(response))
        .catch(error => callBackHandler(error.response));
    }

  }
}
